<template>
  <div class="empty-box">
        <div class="empty-icon">
            <el-image
                src="@/assets/svgs/empty.svg"
                ></el-image>
        </div>
        <div class="empty-text">
            {{emptyText}}
        </div>
  </div>
</template>

<script>
export default {
     props:{
         emptyText:{
            type:String,
            default:'暂无数据'
         }
     },
      data() {
          return {

          }
      },
      methods: {


      },
      //生命周期 - 创建完成
     created(){

     },

     //DOM挂载完毕
     mounted() {

     }
}

</script>
<style lang='less' scoped>
.empty-box{
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .empty-icon{
        margin-top: -60px;
    }
    .empty-text{
        text-align: center;
        color: #999999;
    }
}
</style>
